import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  FormGroup,
  Label,
  Form,
  CustomInput,
  FormText,
} from 'reactstrap';
import {
  BtnOutlineRed,
  BtnOutlineGreen,
  ContFlexRight,
} from '../../../styled-components';
import DateInput from '../../../commons/DateInput';
import moment from 'moment';

const ModalAddPaid = ({ subscription, onAddPayment, profileSubscriptions }) => {
  const [t] = useTranslation('SUBSCRIPTIONS');

  const [date, setDate] = useState('');
  const [type, setType] = useState('');
  const [lastSubscription, setLastSubscription] = useState(null);

  const [errors, setErrors] = useState({
    date: false,
    type: false,
    expireDate: false,
  });

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const onAddPaymentSubmit = async () => {
    if (!date || !type) {
      const errors = {};

      errors.date = !date;
      errors.type = !type;

      if (lastSubscription) {
        const expireDate = lastSubscription.expireDate;
        if (moment(date).isSameOrBefore(moment(expireDate), 'day')) {
          errors.expireDate = true;
        } else {
          errors.expireDate = false;
        }
      }

      return setErrors(errors);
    }
    onAddPayment({
      subscriptionId: subscription._id,
      date,
      type,
    });

    setDate('');
    setType('');
    setErrors({});

    toggle();
  };

  useEffect(() => {
    if (profileSubscriptions && profileSubscriptions.length > 0) {
      const sortedSubscriptions = [...profileSubscriptions].sort((a, b) =>
        moment(b.expireDate).diff(moment(a.expireDate))
      );
      if (sortedSubscriptions.length > 1) {
        setLastSubscription(sortedSubscriptions[1]);
      }
    }
  }, [profileSubscriptions]);

  return (
    <React.Fragment>
      <ContFlexRight>
        <BtnOutlineGreen type="button" className="uppercase" onClick={toggle}>
          {t('ADD_PAID')}
        </BtnOutlineGreen>
      </ContFlexRight>

      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{t('ADD_PAID')}</ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onAddPaymentSubmit();
          }}
        >
          <ModalBody>
            <div className="max-width-form">
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label>{t('RECEIPT_DATE')} *</Label>
                    <DateInput value={date} onChange={setDate} />
                    {errors.date && (
                      <FormText className="error-message">
                        {t('COMMON:REQUIRED')}
                      </FormText>
                    )}
                    {errors.expireDate && (
                      <FormText className="error-message">
                        {t('EXPIRE_DATE_ERROR')}
                      </FormText>
                    )}
                  </FormGroup>
                </Col>
                <Col xs="12">
                  <FormGroup>
                    <Label>{t('IMPORT_TYPE')} *</Label>
                    <CustomInput
                      type="select"
                      id="type"
                      name="customSelect"
                      onChange={(e) => setType(e.target.value)}
                    >
                      <option value="">{t('IMPORT_TYPE_PLACEHOLDER')}</option>
                      <option value="TRANSFER">{t('TRANSFER')}</option>
                      <option value="CARD">{t('CARD')}</option>
                      <option value="RIBA">{t('RIBA')}</option>
                      <option value="CASH">{t('CASH')}</option>
                      <option value="OTHER">{t('OTHER')}</option>
                    </CustomInput>
                    {errors.type && (
                      <FormText className="error-message">
                        {t('COMMON:REQUIRED')}
                      </FormText>
                    )}
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </ModalBody>
          <ModalFooter>
            <BtnOutlineRed type="button" className="uppercase" onClick={toggle}>
              {t('COMMON:CANCEL')}
            </BtnOutlineRed>
            <BtnOutlineGreen type="submit" className="uppercase">
              {t('COMMON:CONFIRM')}
            </BtnOutlineGreen>
          </ModalFooter>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default ModalAddPaid;
